// extracted by mini-css-extract-plugin
module.exports =  {"typography-green":"BCRAghx","typographyGreen":"BCRAghx"};